"use client";

import ContactButton from "@/modules/common/components/ContactButton";

interface ContactButtonWrapperProps {
  phone: string;
}

export function ContactButtonWrapper({ phone }: ContactButtonWrapperProps) {
  return <ContactButton position="right" phone={phone} />;
}
